export function isValidEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
export function matchesSearchQuery(initialText, initialQuery) {
  const text = (initialText || "").trim().toLowerCase();
  const query = (initialQuery || "").trim().toLowerCase();
  return text.includes(query);
}
export function capitalizeMessage(str, addFullstop = true) {
  try {
    let sentance = str.trim();
    sentance = sentance.charAt(0).toUpperCase() + sentance.slice(1);
    return ".,?".includes(sentance[sentance.length - 1]) && addFullstop ? sentance : sentance + ".";
  } catch {
    return str;
  }
}

export function gTagEventTrack(action,eventData){
  if (window.hasOwnProperty('dataLayer')){
      gtag('event', action, eventData);
  }
}

export function validateFullName(str) {
  if (!str.length) {
    return false;
  }

  // full name have to be more then 1 word
  const fullNameWordsCount = str.trim().split(/\s+/).length;
  if (fullNameWordsCount > 1) {
    if (str.match(/\d/)) {
      return false;
    }

    // Allow any alphabets, space, apostrophe, dot and dash between words
    const pattern = /^(?=.{2,300}$)(?!(?:.*-){2,4})\p{L}+(?:[-'. ]\p{L}+)*$/gu;
    return pattern.test(str);
  }
  return false;
}